import mobile from 'is-mobile';

/**
 * Utility class in order to detect the nature of the device.
 */
export class DeviceDetect {
  /**
   * Detect if the device is a mobile.
   *
   * @returns {boolean} True if the device has a mobile User Agent, false otherwise.
   */
  static isMobile() {
    return mobile();
  }

  /**
   *DEtect if the device is "touch-ready".
   *
   * @returns {boolean} If the device has touch events.
   */
  static isTouch() {
    const supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints || navigator.maxTouchPoints;

    return supportsTouch !== undefined && supportsTouch > 0;
  }

  /**
   * Validator if the browser is Internet Explorer.
   *
   * @returns {number} Returns a number of the version of internet explorer.
   */
  static isIE() {
    const ua = navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');

    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');

      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    return false;
  }

  /**
   * Detect if the browser is running on iOS system.
   *
   * @returns {boolean} Returns if the browser is running on iOS system.
   */
  static isIOS() {
    const myNav = navigator.userAgent.toLowerCase();

    return myNav.match(/iphone|ipod|ipad/) !== null;
  }
}
